// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tick-wrapper":"styles__tick-wrapper___a-Z4f","tickWrapper":"styles__tick-wrapper___a-Z4f","tick-border":"styles__tick-border___ThMkz","tickBorder":"styles__tick-border___ThMkz","tick-border-animate":"styles__tick-border-animate___jyvXs","tickBorderAnimate":"styles__tick-border-animate___jyvXs","tick":"styles__tick___1OIYw"};
    if(module.hot) {
      // 1747791810290
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  